// mission-chat-pinned G7 F-3 : the app's sonner <Toaster/>, portalled to
// <body>. sonner 1.7.4 renders in place ; inside the app root it went `inert`
// with the root while the mission pane is a modal / full-screen dialog
// (MissionPane O-1) — toasts were neither announced nor clickable. As a body
// sibling of the root it stays reachable, like every other portalled layer.

import { createPortal } from 'react-dom';
import { Toaster } from 'sonner';

/** @param {import('sonner').ToasterProps} props */
export function AppToaster(props) {
  if (typeof document === 'undefined') return null;
  return createPortal(<Toaster {...props} />, document.body);
}
